import React, { useState, useEffect, Fragment } from "react";

import { ResultProvider } from "../../dataProvider/results";
import { getResultOrigin } from "../../dataProvider/origin";
import { TYPES, SUBTYPES, EXCLUDED_REGIONS } from "../../envs/core";
import "./multiPactometro.scss";
import TableRanking from "../../components/tableRanking";
import PactometroCheck from "../../components/pactometroCheck";
import Button from "../../components/button";
import Autocomplete from "./../../components/autocomplete";
import { PlacesProvider } from "../../dataProvider/places";
import { getData } from "../../dataProvider/places/single";

const getRoute = (type, town) => {
  if (type === TYPES.MUNICIPAL) {
    return `https://www.lasexta.com/noticias/nacional/elecciones-municipales/pactometro/1${town.path}`;
  }
  return `https://www.lasexta.com/noticias/nacional/elecciones-autonomicas/pactometro/1${town.path}`;
};

const isLasexta = window.location.hostname
  .replace("localhost", "antena3")
  .includes("lasexta");
const MultiPactometro = ({ match, history }) => {
  const { year, type, electionNumber, place, reload } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  const [selectedType, setSelectedType] = useState(type);

  const [autocomple, setAutocomple] = useState("");
  const [selectedChecks, setSelectedChecks] = useState([]);

  const [selectedPlace, setSelectedPlace] = useState("");

  const changeSelection = town => {
    setSelectedChecks([]);
    if (Boolean(parseInt(reload)) && isLasexta) {
      window.location.href = getRoute(type, town);
    } else {
      history.push(
        `/${reload}/${year}/${selectedType}/${electionNumber}/${town.ineId}/multipactometro.html`
      );
    }
  };

  useEffect(() => {
    setSelectedType(type);
    getResultOrigin(
      year,
      type,
      electionNumber,
      type === TYPES.REGIONAL ? place : "C108"
    )
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});

    getData(place).then(p => {
      setSelectedPlace(p);
    });
  }, [year, type, electionNumber, place]);

  const changeScope = scope => {
    setSelectedChecks([]);
    if (scope === TYPES.REGIONAL) {
      if (Boolean(parseInt(reload)) && isLasexta) {
        window.location.href = `https://www.lasexta.com/noticias/nacional/elecciones-autonomicas/pactometro/1/comunidad-de-madrid`;
      } else {
        history.push(
          `/${reload}/${year}/${scope}/${electionNumber}/R13/multipactometro.html`
        );
      }
    } else if (scope === TYPES.MUNICIPAL) {
      if (Boolean(parseInt(reload)) && isLasexta) {
        window.location.href = `https://www.lasexta.com/noticias/nacional/elecciones-municipales/pactometro/1/comunidad-de-madrid/madrid/madrid`;
      } else {
        history.push(
          `/${reload}/${year}/${scope}/${electionNumber}/28079/multipactometro.html`
        );
      }
    }
  };
  return (
    <div className="multiPactometroPage">
      {resultOrigin && resultOrigin.primary && (
        <Fragment>
          <ResultProvider
            active={resultOrigin.historic.active}
            year={resultOrigin.historic.year}
            type={selectedType}
            subtype={SUBTYPES.SINGLE}
            electionNumber={electionNumber}
            placeId={place}
            electionPlace={selectedType === TYPES.REGIONAL ? place : ""}
          >
            {oldData => (
              <Fragment>
                <ResultProvider
                  active={resultOrigin.primary.active}
                  year={year}
                  type={selectedType}
                  subtype={SUBTYPES.SINGLE}
                  electionNumber={electionNumber}
                  placeId={place}
                  electionPlace={selectedType === TYPES.REGIONAL ? place : ""}
                  details={selectedType === TYPES.MUNICIPAL}
                >
                  {dataResult => (
                    <div>
                      <Fragment>
                        <div className="buttons">
                          <h2 className="mainTitle">
                            {isLasexta
                              ? "PACTÓMETRO 26M: "
                              : "CALCULADORA ELECTORAL: "}
                            {selectedType === TYPES.REGIONAL
                              ? "Autonomías"
                              : "Municipios"}
                          </h2>
                          <div className="buttonsContainer">
                            <Button
                              className={
                                selectedType === TYPES.REGIONAL ? "current" : ""
                              }
                              onClick={() => changeScope(TYPES.REGIONAL)}
                            >
                              Autonómicas
                            </Button>
                            <Button
                              className={
                                selectedType === TYPES.MUNICIPAL
                                  ? "current"
                                  : ""
                              }
                              onClick={() => changeScope(TYPES.MUNICIPAL)}
                            >
                              Municipales
                            </Button>
                          </div>
                        </div>
                        <div className="cityToggleWrapper">
                          <div className="cityTitleWrapper">
                            <h3 className="cityTitle">{selectedPlace.name}</h3>
                          </div>
                          <div className="autocompleteWrapper">
                            <div className="cityToggle">
                              {/* <span className="autocompleteLabel">Cambiar</span> */}
                              <PlacesProvider
                                type={
                                  selectedType === TYPES.REGIONAL
                                    ? "REGION"
                                    : "TOWN"
                                }
                                name={autocomple}
                                parentId={
                                  selectedType === TYPES.REGIONAL
                                    ? "C108"
                                    : null
                                }
                                excludedGrandParentIds={
                                  selectedType === TYPES.REGIONAL
                                    ? EXCLUDED_REGIONS
                                    : []
                                }
                                sortby={autocomple ? "score" : "name"}
                              >
                                {data => {
                                  return (
                                    <Autocomplete
                                      results={data}
                                      onChange={value => setAutocomple(value)}
                                      onSelect={value => changeSelection(value)}
                                      placeholder={
                                        selectedType === TYPES.REGIONAL
                                          ? "Selecciona una comunidad"
                                          : "Selecciona un municipio"
                                      }
                                      showArrow
                                    />
                                  );
                                }}
                              </PlacesProvider>
                            </div>
                          </div>
                        </div>
                        <div className="multiPactometroWrapper">
                          <div className="rankingWrapper">
                            <TableRanking
                              currentData={dataResult}
                              pastData={oldData}
                              place={
                                selectedType === TYPES.REGIONAL ? false : place
                              }
                            />
                          </div>
                          <div className="pactometroWrapper">
                            <PactometroCheck
                              selecteds={selectedChecks}
                              totalSeat={dataResult.totalSeats}
                              seatData={
                                dataResult && dataResult.partiesResult
                                  ? dataResult.partiesResult
                                  : []
                              }
                              type={
                                selectedType === TYPES.REGIONAL
                                  ? "REGIONAL"
                                  : "MUNICIPAL"
                              }
                            />
                          </div>
                        </div>
                      </Fragment>
                    </div>
                  )}
                </ResultProvider>
              </Fragment>
            )}
          </ResultProvider>
        </Fragment>
      )}
    </div>
  );
};

export default MultiPactometro;
